module.exports = __webpack_public_path__ + "static/img/zijianPlat.e3669f9b.jpg";